import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import ReactSelect from "../../../Components/PortalSelect";
import { RevertBackSchema } from "../../../ValidationSchema";
import Modal from "../../../Components/Modal";

const GraphicDesignerPreviewMokup = ({ show, userId, orderId, onClose }) => {
  const Navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const [data, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [activePreviewIndex, setActivePreviewIndex] = useState(0);

  useEffect(() => {
    if (show && userId && orderId) {
      axios
        .get(
          `${process.env.REACT_APP_URL}/admin/graphic_designer/order/products/design`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          }
        )
        .then((res) => {
          const filter = res?.data?.data.filter(
            (item) => item.order_id === orderId
          );
          setData(filter || []);
        })
        .catch((err) => {
          setData([]);
          setActivePreviewIndex(0);
          if (err.response?.data?.message === "Unauthorized!") {
            Navigate("/");
          }
        });
    }
  }, [page, search, userId, orderId, show, Navigate]);

  const handleThumbnailClick = (index) => {
    setActivePreviewIndex(index);
  };

  const handleRemoveDesign = async (indexToRemove, orderId) => {
    const fileToDelete = data[indexToRemove]?.design_url;

    try {
      if (!orderId) {
        toast.error("Order ID is required before removing media.");
        return;
      }

      const res = await axios.delete(
        `${process.env.REACT_APP_URL}/admin/graphic_designer/design/${data[indexToRemove]?.graphic_design_id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("Token")}` },
        }
      );

      if (res.status === 200) {
        toast.success(res.data.message);

        const updatedData = data.filter((_, i) => i !== indexToRemove);

        if (indexToRemove === activePreviewIndex) {
          setActivePreviewIndex(0);
        } else if (indexToRemove < activePreviewIndex) {
          setActivePreviewIndex((prev) => prev - 1);
        }

        setData(updatedData);
      } else {
        toast.error("Failed to remove media.");
      }
    } catch (err) {
      console.error("Remove media error:", err);
      toast.error(err?.response?.data?.message || "Something went wrong");
    }
  };

  // Close modal when clicking outside
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const active = data?.[activePreviewIndex];

  return (
    <Modal
      open={!!show}
      onClose={onClose}
      title="Products Mockup"
      subtitle={
        data?.length > 0
          ? `${data.length} design${data.length === 1 ? "" : "s"} uploaded`
          : "No designs uploaded yet"
      }
      size="lg"
    >
      {data?.length > 0 ? (
        <>
          <div className="al-stage">
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}${active?.design_url}`}
              alt="Selected design"
            />
          </div>

          <div className="al-picker">
            {data.map((item, index) => (
              <div key={index} style={{ position: "relative" }}>
                <button
                  type="button"
                  className={`al-picker__i ${
                    index === activePreviewIndex ? "is-active" : ""
                  }`}
                  onClick={() => handleThumbnailClick(index)}
                  title={`Design ${index + 1}`}
                >
                  <img
                    src={`${process.env.REACT_APP_IMAGE_URL}${item.design_url}`}
                    alt={`Design ${index + 1}`}
                  />
                </button>
                <button
                  type="button"
                  className="al-picker__x"
                  title="Remove this design"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveDesign(index, item.order_id);
                  }}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="al-empty" style={{ padding: "32px 20px" }}>
          <p className="al-empty__title">No designs found</p>
          <p className="al-empty__text">
            Mockups uploaded for this order will appear here.
          </p>
        </div>
      )}
    </Modal>
  );
};

export default GraphicDesignerPreviewMokup;
